export const ADMIN_TOKEN_UPDATED = 'ADMIN_TOKEN_UPDATED';
